import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { IJsonDate } from '../../System/IJsonDate';

declare var IS_RUNNING_IN_APP_POOL;

export class BusinessDaysClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(numberOfDays: number, futureOrPast: number, baseDate: IJsonDate, max: boolean): Promise<IJsonDate, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Common/BusinessDays/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { numberOfDays: numberOfDays, futureOrPast: futureOrPast, baseDate: baseDate, max: max }

    return AjaxWrapper.get<IJsonDate, any>(url, data);
  }
}

